export default "__VITE_ASSET__CpQZAoti__"